import http from "@http"
//部门树
export function getDeptTree(data) {
    return http({
        url: '/lskj-admin/api/admin/dept/tree',
        method: "post",
        data
    })
}
//部门列表
export function getDeptList(data) {
    return http({
        url: '/lskj-admin/api/admin/dept/list',
        method: "post",
        data
    })
}
//查询单条部门信息
export function deptById(data) {
    return http({
        url: `/lskj-admin/api/admin/dept/byId?id=${data.id}`,
        method: "get",
    })
}
//添加部门
export function deptAdd(data) {
    return http({
        url: '/lskj-admin/api/admin/dept/add',
        method: "post",
        data
    })
}

//修改部门信息
export function updeteDept(data) {
    return http({
        url: `/lskj-admin/api/admin/dept`,
        method: "put",
        data
    })
}
//删除部门信息
export function deleteDept(data) {
    return http({
        url: `/lskj-admin/api/admin/dept?ids=${data.ids}`,
        method: "delete",
        data
    })
}